export default {
  POST_USER: "POST_USER",
  VALIDATE_USER: "VALIDATE_USER",
};
